import { useQuery } from '@tanstack/react-query';
import { fetchCartCheckoutMeta } from './apiFetchCartCheckoutMeta';
import { ShoppingCartMetaOut } from '../../../../../store/api';
import { ErrorResponse } from '../../../../../shared/notification/actions';
import { typedFailure } from '../../../../checkout/utils/request-error';
import { PATH_CART } from '../../../../../store/constants';
import { useNotification } from '../../../../../app-store/notification/useNotification';
import { useNavigate } from 'react-router-dom';
import { GlobalReactQueryOptions } from '../../../../../config';
import { useTranslation } from 'react-i18next';

const CART_CHECKOUT_META_QUERY = 'cartCheckoutMeta';

export const useCartCheckoutMeta = () => {
    const { showNotificationWithInfo } = useNotification();
    const navigate = useNavigate();
    const { t } = useTranslation();

    return useQuery<ShoppingCartMetaOut, ErrorResponse>([CART_CHECKOUT_META_QUERY], () => fetchCartCheckoutMeta(), {
        ...GlobalReactQueryOptions,
        onError: error => typedFailure(error, PATH_CART, showNotificationWithInfo, navigate, t)
    });
};
